    /* ============================================================
       V5 homepage behaviour.

       Every feature is scoped to a root element and safe to run again,
       because the theme editor replaces a section's DOM on each setting
       change. Re-running on shopify:section:load is what keeps the clock
       ticking, the reveal animations from stranding elements at opacity 0,
       and the listeners bound to nodes that are still on the page.
       ============================================================ */
    (function () {
      'use strict';

      var DOC = '__document__';
      var BAR = '__bar__';
      var SCROLL = '__scroll__';
      var teardown = {};

      function register(id, fn) { (teardown[id] || (teardown[id] = [])).push(fn); }
      function destroy(id) {
        var list = teardown[id];
        if (!list) return;
        for (var i = 0; i < list.length; i++) { try { list[i](); } catch (e) {} }
        delete teardown[id];
      }
      function every(id, ms, fn) { var t = setInterval(fn, ms); register(id, function () { clearInterval(t); }); return t; }
      function listen(id, el, type, fn, opts) {
        el.addEventListener(type, fn, opts);
        register(id, function () { el.removeEventListener(type, fn, opts); });
      }
      function all(root, sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); }
      function reduced() { return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches; }
      function designMode() { return !!(window.Shopify && window.Shopify.designMode); }

      /* ---------------------------------------------------------------
         Scroll-host adoption repair.

         The Brandify app embed loads OverlayScrollbars asynchronously and binds
         it to <body>. At the instant it initialises, the library moves the body's
         current children into .os-padding > .os-viewport > .os-content, which
         becomes the real scroll container. On a slow connection it can fire while
         the document is still streaming, so everything parsed AFTER that moment -
         the footer section group, .search--popdown, the modal container - is
         appended to <body> as a SIBLING of .os-padding and never enters the
         scroller.

         body is position:absolute with top:0/bottom:0 and overflow:hidden, so an
         orphaned section renders at the top of the viewport instead of at the end
         of the document: painted over the page, clipped, and with its height
         missing from the scrollable range. Measured on an iPhone at scrollTop 0:
         .foot had offsetTop 0 and rect top 0, overlapping .hero-micro at 629,
         while .os-viewport scrollHeight (12466) stopped at the end of the page
         content (12440) and excluded the footer's 1827px entirely.

         The split is always a clean prefix/suffix of document order - everything
         before the cut is inside, everything after is outside - so re-appending
         the strays in order restores the original order exactly.

         Only the theme's own top-level content is adopted. Third-party mounts
         (cart, pixels, popups) are deliberately left where they are: they are
         fixed-position or script-owned and several expect to be body children.

         No-op when the library won the race, and no-op when the app embed is off
         and scrolling is native. --------------------------------------------- */
      function adoptStraySections() {
        var content = document.querySelector('.os-content');
        if (!content) return 0;
        var strays = [];
        for (var n = document.body.firstElementChild; n; n = n.nextElementSibling) {
          if (!n.classList) continue;
          if (n.classList.contains('shopify-section') ||
              (n.tagName === 'MAIN' && n.classList.contains('main-content'))) {
            strays.push(n);
          }
        }
        if (!strays.length) return 0;
        strays.forEach(function (el) { content.appendChild(el); });
        try {
          var inst = window.OverlayScrollbars && OverlayScrollbars(document.body);
          if (inst && inst.update) inst.update(true);
        } catch (e) {}
        return strays.length;
      }

      /* The race can land either side of this script, so retry on a short
         schedule and watch <body> for the moment the library installs itself. */
      function initScrollHostAdoption() {
        destroy(SCROLL);
        adoptStraySections();
        listen(SCROLL, window, 'load', adoptStraySections);
        [250, 800, 2000, 4000].forEach(function (ms) {
          var t = setTimeout(adoptStraySections, ms);
          register(SCROLL, function () { clearTimeout(t); });
        });
        if (window.MutationObserver) {
          var mo = new MutationObserver(function () { adoptStraySections(); });
          mo.observe(document.body, { childList: true });
          var stop = setTimeout(function () { mo.disconnect(); }, 12000);
          register(SCROLL, function () { mo.disconnect(); clearTimeout(stop); });
        }
      }

      /* Live clock, always America/New_York whatever the visitor's zone.
         hourCycle h23 keeps midnight at 00, where hour12:false can print 24. */
      var clockFmt = null;
      function clockText() {
        if (!clockFmt) {
          try {
            clockFmt = new Intl.DateTimeFormat('en-US', { timeZone: 'America/New_York', hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23' });
          } catch (e) {
            clockFmt = new Intl.DateTimeFormat('en-US', { hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23' });
          }
        }
        var p = {};
        clockFmt.formatToParts(new Date()).forEach(function (x) { p[x.type] = x.value; });
        return p.hour + ':' + p.minute + ':' + p.second;
      }
      function initClock(root, id) {
        var els = all(root, '#clock, #clock2');
        if (!els.length) return;
        function tick() {
          var t = clockText();
          els.forEach(function (e) { e.textContent = t; });
        }
        tick(); every(id, 1000, tick);
      }

      /* Reveal on scroll. One observer for the whole page; new nodes just get
         handed to it. In the theme editor there is no scroll journey to wait
         for, so freshly rendered content is shown at once. */
      var revealObs = null;
      function revealObserver() {
        if (revealObs || !('IntersectionObserver' in window)) return revealObs;
        revealObs = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            if (e.isIntersecting) { e.target.classList.add('in'); revealObs.unobserve(e.target); }
          });
        }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
        return revealObs;
      }
      function initReveal(root) {
        var items = all(root, '.reveal, .rvg');
        var obs = designMode() ? null : revealObserver();
        if (!obs) { items.forEach(function (el) { el.classList.add('in'); }); return; }
        items.forEach(function (el) { obs.observe(el); });
      }

      /* Top bar theme follows the section underneath it.

         Each homepage section carries data-header="dark|light" (its Header
         theme setting). Sections without one fall back to their colour scheme,
         so pages that only set data-v5-scheme keep working.

         An IntersectionObserver watches a one-pixel line at the vertical middle
         of the bar, isolated with rootMargin, so the switch happens exactly when
         a section edge crosses the middle of the bar, not when a section fills
         most of the viewport. Whatever is under that line sets
         data-header-theme on the bar. The markup ships without the attribute,
         and the CSS treats "no attribute" as the dark set, so a page where this
         script never runs looks exactly like the dark header.

         .is-lite is still toggled for v5-chrome.css, which styles the bar on
         the non-homepage templates. */
      function initBar() {
        destroy(BAR);
        var bar = document.getElementById('bar');
        if (!bar || !('IntersectionObserver' in window)) return;
        var zones = all(document, '[data-header], [data-v5-scheme]');
        var under = [];
        var obs = null;
        function themeOf(el) {
          var t = el.getAttribute('data-header');
          if (t === 'light' || t === 'dark') return t;
          return el.getAttribute('data-v5-scheme') === 'light' ? 'light' : 'dark';
        }
        function apply() {
          /* At an exact edge two sections can both touch the line; the later
             one in document order is the one scrolling in. */
          var t = under.length ? themeOf(under[under.length - 1]) : 'dark';
          if (bar.getAttribute('data-header-theme') !== t) bar.setAttribute('data-header-theme', t);
          bar.classList.toggle('is-lite', t === 'light');
        }
        function onHit(entries) {
          entries.forEach(function (e) {
            var i = under.indexOf(e.target);
            if (e.isIntersecting && i < 0) under.push(e.target);
            else if (!e.isIntersecting && i >= 0) under.splice(i, 1);
          });
          under.sort(function (a, b) {
            return a.compareDocumentPosition(b) & Node.DOCUMENT_POSITION_FOLLOWING ? -1 : 1;
          });
          apply();
        }
        function build() {
          if (obs) obs.disconnect();
          under = [];
          var line = Math.round((bar.offsetHeight || 58) / 2);
          var below = Math.max(window.innerHeight - line - 1, 0);
          obs = new IntersectionObserver(onHit, { rootMargin: '-' + line + 'px 0px -' + below + 'px 0px', threshold: 0 });
          zones.forEach(function (z) { obs.observe(z); });
          if (!zones.length) apply();
        }
        var resizeT;
        listen(BAR, window, 'resize', function () { clearTimeout(resizeT); resizeT = setTimeout(build, 120); });
        register(BAR, function () { clearTimeout(resizeT); if (obs) obs.disconnect(); });
        build();
      }

      /* Mobile hamburger menu */
      function initNav(root, id) {
        var burger = root.querySelector('#burger'), menu = root.querySelector('#navmenu');
        if (!burger || !menu) return;
        function setOpen(open) {
          document.body.classList.toggle('nav-open', open);
          burger.setAttribute('aria-expanded', open ? 'true' : 'false');
        }
        listen(id, burger, 'click', function () { setOpen(!document.body.classList.contains('nav-open')); });
        all(menu, 'a').forEach(function (a) { listen(id, a, 'click', function () { setOpen(false); }); });
        /* No width-based auto-close any more: the panel is the primary navigation
           at every width, not a mobile-only fallback. */
        listen(id, document, 'keydown', function (e) { if (e.key === 'Escape') setOpen(false); });
        register(id, function () { document.body.classList.remove('nav-open'); });
      }

      /* Stats count-up. Values render with a thousands separator (5,300),
         matching the server-rendered text in v5-stats.liquid. */
      function fmtCount(n) {
        try { return n.toLocaleString('en-US'); } catch (e) { return String(n); }
      }
      function initStats(root, id) {
        var sec = root.querySelector('#stats'); if (!sec) return;
        var vals = all(sec, '.stats__val[data-count]');
        var reduce = reduced();
        var done = false;
        function run() {
          if (done) return; done = true;
          vals.forEach(function (el) {
            var target = parseInt(el.getAttribute('data-count'), 10) || 0;
            if (reduce || target === 0) { el.textContent = fmtCount(target); return; }
            var dur = 1150, start = null;
            function step(ts) {
              if (start === null) start = ts;
              var p = Math.min((ts - start) / dur, 1);
              var eased = 1 - Math.pow(1 - p, 3);
              el.textContent = fmtCount(Math.round(eased * target));
              if (p < 1) requestAnimationFrame(step); else el.textContent = fmtCount(target);
            }
            requestAnimationFrame(step);
          });
        }
        if (!('IntersectionObserver' in window) || designMode()) { run(); return; }
        var obs = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) { if (e.isIntersecting) { run(); obs.disconnect(); } });
        }, { threshold: 0.35 });
        obs.observe(sec);
        register(id, function () { obs.disconnect(); });
      }

      /* Hero rotating word - cinematic fade */
      function initRotor(root, id) {
        var rotorEl = root.querySelector('#rotor');
        if (!rotorEl || reduced()) return;
        var word = rotorEl.querySelector('.word');
        var words = (rotorEl.getAttribute('data-words') || 'look,age,recover,sleep,perform,feel')
          .split(',').map(function (w) { return w.trim(); }).filter(Boolean);
        if (!word || !words.length) return;
        var i = 0, swap;
        every(id, 3800, function () {
          word.classList.add('fade');
          swap = setTimeout(function () {
            i = (i + 1) % words.length;
            word.textContent = words[i];
            word.classList.remove('fade');
          }, 900);
        });
        register(id, function () { clearTimeout(swap); });
      }

      /* Catalogue rows - inject each category photo as the in-row wipe layer */
      function initCatalogue(root, id) {
        var list = root.querySelector('#catList');
        if (!list) return;
        all(list, '.cat__row').forEach(function (row) {
          var src = row.getAttribute('data-img');
          if (!src || row.querySelector('.cat__row-img')) return;
          var img = document.createElement('span');
          img.className = 'cat__row-img';
          img.setAttribute('aria-hidden', 'true');
          img.style.backgroundImage = "url('" + src + "')";
          row.insertBefore(img, row.firstChild);
        });
      }

      /* Survey - static image, rotating testimonials (sequential fade, no ghost) */
      function initSurvey(root, id) {
        var stage = root.querySelector('#surveyStage'), dotsWrap = root.querySelector('#surveyDots');
        if (!stage || !dotsWrap) return;
        var gap = parseInt(stage.getAttribute('data-interval'), 10) || 6000;
        var reduce = reduced();
        var slides = all(stage, '.survey__slide'), idx = 0, timer, fadeT;
        if (!slides.length) return;
        dotsWrap.innerHTML = '';
        slides.forEach(function (s, n) {
          s.classList.toggle('on', n === 0);
          var d = document.createElement('button');
          d.type = 'button';
          d.className = 'survey__dot' + (n === 0 ? ' on' : '');
          d.setAttribute('aria-label', 'Testimonial ' + (n + 1));
          d.addEventListener('click', function () { go(n); reset(); });
          dotsWrap.appendChild(d);
        });
        var dots = Array.prototype.slice.call(dotsWrap.children);
        /* The active dot's fill (v5-base.css) runs for exactly one interval.
           With autoplay off there is nothing to count down, so it shows solid. */
        dotsWrap.style.setProperty('--survey-gap', gap + 'ms');
        dotsWrap.classList.toggle('is-static', reduce);
        /* Slides are absolutely positioned for the crossfade, so the stage
           never grows to fit them - a long quote pair overflows past the
           fixed mobile min-height and runs into the dot strip below.
           Measure the active slide and push its height onto the stage. */
        function sizeStage() {
          var h = slides[idx] && slides[idx].offsetHeight;
          if (h) stage.style.minHeight = h + 'px';
        }
        function go(n) {
          if (n === idx) return;
          clearTimeout(fadeT);
          slides[idx].classList.remove('on'); dots[idx].classList.remove('on');
          idx = n; dots[idx].classList.add('on');
          sizeStage();
          fadeT = setTimeout(function () { slides[idx].classList.add('on'); }, 640);
        }
        function next() { go((idx + 1) % slides.length); }
        /* Re-adding .on restarts the fill animation from empty, so it lines up
           with a freshly started interval. */
        function restartFill() {
          var d = dots[idx];
          d.classList.remove('on'); void d.offsetWidth; d.classList.add('on');
        }
        function stop() { clearInterval(timer); dotsWrap.classList.add('is-paused'); }
        function reset() {
          if (reduce) return;
          clearInterval(timer);
          dotsWrap.classList.remove('is-paused');
          restartFill();
          timer = setInterval(next, gap);
        }
        listen(id, stage, 'mouseenter', stop);
        listen(id, stage, 'mouseleave', reset);
        listen(id, stage, 'focusin', stop);
        listen(id, stage, 'focusout', reset);
        listen(id, window, 'resize', sizeStage);
        register(id, function () { stop(); clearTimeout(fadeT); });
        sizeStage();
        if (!reduce) reset();
      }

      /* Library archive - hover a row to swap the large preview */
      function initLibrary(root, id) {
        var list = root.querySelector('#libList'), preview = root.querySelector('#libPreview'), cap = root.querySelector('#libCap');
        if (!list || !preview) return;
        var rows = all(list, '.lib__row');
        var imgs = all(preview, 'img');
        function activate(i, cptn) {
          imgs.forEach(function (im) { im.classList.toggle('on', im.getAttribute('data-i') === i); });
          rows.forEach(function (r) { r.classList.toggle('is-active', r.getAttribute('data-i') === i); });
          if (cptn && cap) cap.textContent = cptn;
        }
        rows.forEach(function (row) {
          listen(id, row, 'mouseenter', function () {
            activate(row.getAttribute('data-i'), row.getAttribute('data-cap'));
          });
        });
      }

      /* FAQ exclusive accordion: opening one closes the others */
      function initFaq(root, id) {
        var items = all(root, '.faq__item');
        items.forEach(function (d) {
          listen(id, d, 'toggle', function () {
            if (d.open) items.forEach(function (o) { if (o !== d) o.open = false; });
          });
        });
      }

      /* Footer link columns: stacked accordion below 760px, always open above.
         The markup ships open so a script failure leaves the footer expanded
         rather than collapsed with no way to open it. Only syncs when the
         breakpoint is actually crossed, so a column the visitor opened on a
         phone is not slammed shut by an unrelated resize. */
      function initFooterAccordion(root, id) {
        var cols = all(root, 'details.foot__col');
        if (!cols.length || !window.matchMedia) return;
        var mq = window.matchMedia('(max-width: 760px)');
        var wasMobile = null;
        /* Only acts when the breakpoint is actually crossed, so a column the
           visitor opened is never closed by an unrelated resize. Backed by the
           resize event as well as the media query: the change event does not
           fire in every environment, and missing it strands the columns closed
           on desktop, where there is no affordance to reopen them. */
        function sync() {
          if (mq.matches === wasMobile) return;
          wasMobile = mq.matches;
          cols.forEach(function (d) { d.open = !wasMobile; });
        }
        sync();
        listen(id, window, 'resize', sync);
        if (mq.addEventListener) {
          mq.addEventListener('change', sync);
          register(id, function () { mq.removeEventListener('change', sync); });
        } else if (mq.addListener) {
          mq.addListener(sync);
          register(id, function () { mq.removeListener(sync); });
        }
      }

      /* Marquee: track content is duplicated in Liquid for seamless loop */

      function initSection(root, id) {
        initClock(root, id);
        initReveal(root);
        initNav(root, id);
        initStats(root, id);
        initRotor(root, id);
        initCatalogue(root, id);
        initSurvey(root, id);
        initLibrary(root, id);
        initFaq(root, id);
        initFooterAccordion(root, id);
      }

      function sectionId(e) {
        if (e.detail && e.detail.sectionId) return e.detail.sectionId;
        return (e.target && e.target.id) || DOC;
      }

      initSection(document, DOC);
      initBar();
      initScrollHostAdoption();

      document.addEventListener('shopify:section:load', function (e) {
        var id = sectionId(e);
        destroy(id);
        initSection(e.target, id);
        initBar();
      });
      document.addEventListener('shopify:section:unload', function (e) {
        destroy(sectionId(e));
        initBar();
      });
      document.addEventListener('shopify:section:reorder', initBar);
    })();
